/* eslint-disable prettier/prettier */
import React from 'react';

import moment from 'moment'
import Datetime from "react-datetime";
import DatePicker from 'react-date-picker';
import DateTimePicker from 'react-datetime-picker'

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Check from '@material-ui/icons/Check';
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Switch from '@material-ui/core/Switch';


import ModalPartyDetails from './ModalPartyDetails.jsx'

const EditPartyDateDetails = (props) => {
    const militaryTime = ['', '0000', '0100', '0200', '0300', '0400', '0500', '0600', '0700', '0800', '0900', '1000', '1100', '1200', '1300', '1400', '1500', '1600', '1700', '1800', '1900', '2000', '2100', '2200', '2300'];
    const { arr, arrString, businessQuery, userQuery, errorMessage, classes, handleChange, handleNotificationsToggle, handleSelectChangeObj, handleArrChange, handleDateChange, handleToggleServices, saveInfo, assignBusiness, assignUser } = props;

    const displayArrString = arrString.toLowerCase().split(' ').map(s => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');

    let newDate;
    if ("seconds" in arr.date) {
        newDate = new Date(arr.date.seconds * 1000);
    } else {
        newDate = arr.date;
    }

    return (
        <div>

            <GridContainer>
                <GridItem xs={12}>
                    <h4 className={classes.bodyText}><b>{displayArrString} Details</b></h4>
                </GridItem>

                <GridItem xs={12}>

                    <ModalPartyDetails
                        arr={arr}
                        userQuery={userQuery}
                        businessQuery={businessQuery}
                        assignBusiness={assignBusiness}
                        assignUser={assignUser}
                        classes={classes}
                        arrString={arrString}
                        locationType={true}
                        handleChange={handleChange}
                        handleArrChange={handleArrChange}
                        handleNotificationsToggle={handleNotificationsToggle}
                        handleSelectChangeObj={handleSelectChangeObj}

                    />

                </GridItem>

            </GridContainer>
            {/* {console.log(`${JSON.stringify(arr['date']).split("T")[1].split(":")[0]}00`)} */}
            <GridContainer style={{ marginTop: "10px" }}>
                {arrString === 'origin' ?
                    <React.Fragment>
                        <GridItem xs={6}>
                            <p>Pickup Date</p>
                            <DateTimePicker
                                value={newDate}
                                onChange={(e) => handleDateChange(e, arrString)}
                            />
                            {console.log("ERROR", arrString)}

                            <InputLabel
                                htmlFor="startTimeWindow"
                                className={classes.selectLabel}>
                                START WINDOW
                                   </InputLabel>
                            <Select
                                MenuProps={{
                                    className: classes.selectMenu
                                }}
                                classes={{
                                    select: classes.select
                                }}
                                value={arr['startTimeWindow']}
                                onChange={(e) => handleSelectChangeObj(e, 'origin')}
                                defaultValue={arr['startTimeWindow'] ? arr['startTimeWindow'] : ''}
                                inputProps={{
                                    id: 'startTimeWindow',
                                    name: 'startTimeWindow'
                                }}
                            >
                                {
                                    militaryTime.map((item) => (
                                        <MenuItem
                                            classes={{
                                                root: classes.selectMenuItem
                                            }}
                                            value={item}
                                            key={item}
                                        >{item}</MenuItem>
                                    ))
                                }
                            </Select>


                            <GridItem xs={1}>
                                <p>and</p>
                            </GridItem>


                            <FormControl
                                fullWidth
                                className={classes.selectFormControl}
                            >
                                <InputLabel
                                    htmlFor="endTimeWindow"
                                    className={classes.selectLabel}>
                                    END WINDOW
                                </InputLabel>

                                <Select
                                    MenuProps={{
                                        className: classes.selectMenu
                                    }}
                                    classes={{
                                        select: classes.select
                                    }}
                                    value={arr['endTimeWindow']}
                                    onChange={(e) => handleSelectChangeObj(e, 'origin')}
                                    defaultValue={arr['zip'] ? ArrayBuffer['zip'] : ''}
                                    inputProps={{
                                        id: 'endTimeWindow',
                                        name: 'endTimeWindow'
                                    }}
                                >
                                    {
                                        militaryTime.map((item) => (
                                            <MenuItem
                                                classes={{
                                                    root: classes.selectMenuItem
                                                }}
                                                value={item}
                                                key={item}
                                            >{item}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>

                        </GridItem>

                    </React.Fragment>
                    : null
                }
                <GridItem xs={12} md={6}>
                {/* Customer Notifications?
                <Switch
                              checked={arr["notifications"]}
                              onChange={(e) => handleNotificationsToggle(e, arrString)}
                              classes={{
                                switchBase: classes.switchBase,
                                checked: classes.switchChecked,
                                icon: classes.switchIcon,
                                iconChecked: classes.switchIconChecked,
                                bar: classes.switchBar,
                              }}
                            /> */}
                    <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                    <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    tabIndex={-1}
                                    onClick={handleToggleServices.bind(null, 'Lift Gate', arrString)}
                                    checked={arr.services.indexOf('Lift Gate') !== -1 ? true : false}
                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                    icon={<Check className={classes.uncheckedIcon} />}
                                    color="primary"
                                    classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot
                                    }}
                                />
                            }
                            classes={{ label: classes.bodyText }}
                            label='Lift Gate at Pickup Point'
                        />
                    </div>
                    <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    tabIndex={-1}
                                    onClick={handleToggleServices.bind(null, 'Dock High Only Facility', arrString)}
                                    checked={arr.services.indexOf('Dock High Only Facility') !== -1 ? true : false}
                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                    icon={<Check className={classes.uncheckedIcon} />}
                                    color="primary"
                                    classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot
                                    }}
                                />
                            }
                            classes={{ label: classes.bodyText }}
                            label='Dock High Only Facility'
                        />
                    </div>
                    <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    tabIndex={-1}
                                    onClick={handleToggleServices.bind(null, 'Inside Pickup', arrString)}
                                    checked={arr.services.indexOf('Inside Pickup') !== -1 ? true : false}
                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                    icon={<Check className={classes.uncheckedIcon} />}
                                    color="primary"
                                    classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot
                                    }}
                                />
                            }
                            classes={{ label: classes.bodyText }}
                            label='Inside Pickup'
                        />
                    </div>
                    <div className={classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    tabIndex={-1}
                                    onClick={handleToggleServices.bind(null, 'Ground Level Access Only', arrString)}
                                    checked={arr.services.indexOf('Ground Level Access Only') !== -1 ? true : false}
                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                    icon={<Check className={classes.uncheckedIcon} />}
                                    color="primary"
                                    classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot
                                    }}
                                />
                            }
                            classes={{ label: classes.bodyText }}
                            label='Ground Level Access Only'
                        />
                    </div>
                    <CustomInput
                        labelText="Custom Extra Service"
                        id="customExtraService"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            required: true,
                            type: "text",
                            onChange: (event) => handleArrChange(event, arrString),
                            defaultValue: arr['customExtraService'] ? arr['customExtraService'] : ''
                        }}
                    />

                </GridItem>
            </GridContainer>

            {errorMessage && <p>{errorMessage}</p>}
        </div>
    )
}

export default EditPartyDateDetails;


// WEBPACK FOOTER //
// ./src/components/Forms/ModalEditPartyDateDetails.jsx